import React from 'react';
import EditDetails from './EditDetails';
import investPlan from '../Investment/Images/investment-main2.jpg';
import { useState, useEffect } from 'react';
import GuaranteedInvestment from "./GuaranteedInvestment";
import ParticipatingPlan from './ParticipatingPlan';
import MouseAwayPopup from '../Investment/MouseAwayPop/MouseAwayPopup'

const Invesment = (props) => {
    const [RequestType, setRequestType] = useState(0);
    const [IsOpenPopup, setIsOpenPopup] = useState(false);
    const [isPopupShown, setIsPopupShown] = useState(false);
    const [isPopupClosed, setIsPopupClosed] = useState(false);
    const [getMobileNumber, setGetMobileNumber] = useState("")

    useEffect(() => {
        if (props.inv === "participating") {
            setRequestType(3);
        } else if (props.inv === "guaranteed") {
            setRequestType(2);
        } else {
            setRequestType(1);
        }
    }, [props.inv]);


    useEffect(() => {
        if (!isPopupShown && !isPopupClosed) {
            const handleMouseLeave = (event) => {
                if (event.clientY <= 10) {
                    setIsOpenPopup(true);
                    setIsPopupShown(true);
                    document.removeEventListener("mouseleave", handleMouseLeave);
                }
            };

            document.addEventListener("mouseleave", handleMouseLeave);
            return () => {
                document.removeEventListener("mouseleave", handleMouseLeave);
            };
        }
    }, [isPopupShown, isPopupClosed]);

    const handleClosePopup = () => {
        setIsOpenPopup(false);
        setIsPopupClosed(true);
    };



    const handleGetMobile = (param) => {
        setGetMobileNumber(param)
    }



    return (
        <>
            {RequestType === 1 && <div>
                <section className="InvestmentLoginFullPage InvestmentLoginPage">
                    <div className="container">
                        <div className="InvestmentMainPage">
                            <div className="LoginInvestment">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="Inv_mainHead">
                                            <h4>Unlock Your Financial Potential with <span className="green-text">Investment Plans at Lowest Rates</span></h4>
                                        </div>
                                        
                                        {/*<small className="ContentPara">We suggest best plans as per your life stage</small>*/}
                                        <div className="InvestMobile hideImgINMob">
                                            <img src={investPlan} className="InvestImage" alt="Invest Plan" />
                                            {/* <div>
                                                <div className="GetBenefits">
                                                    <img src={taxBenefit} alt="Tax Benefit" />
                                                    <div className="GetBenefitsCNT">
                                                        <p>Get tax benefits up to</p>
                                                        <h1>₹ 1.5 Lakh</h1>
                                                        <p>under section 80C</p>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="col-lg-5 offset-lg-1">
                                        <EditDetails />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>}
            {RequestType===2 && < div >
                <section className="InvestmentLoginPage">
                    <div className="container">
                        <div className="InvestmentMainPage">
                            <div className="LoginInvestment">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <GuaranteedInvestment />
                                    </div>
                                    <div className="col-lg-5 offset-lg-1">
                                        <EditDetails RequestType={RequestType} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>}
            {RequestType===3 && < div >
                <section className="InvestmentLoginPage">
                    <div className="container">
                        <div className="InvestmentMainPage">
                            <div className="LoginInvestment">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <ParticipatingPlan />
                                    </div>
                                    <div className="col-lg-5 offset-lg-1">
                                        <EditDetails RequestType={RequestType} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>}
            {IsOpenPopup && (
                <MouseAwayPopup onClose={handleClosePopup} IsMobileNumber={getMobileNumber} />
            )}
        </>
    );
}
export default Invesment;